import React from 'react';

const OperatorLabel = ({ operator, isFirst = false }) => (
  <div className={`flex items-center ${!isFirst ? 'ml-2' : ''}`}>
    <div className="bg-gray-100 text-gray-600 text-xs font-medium px-2 py-1 rounded w-fit">
      {operator === 'and' ? 'AND' : 'OR'}
    </div>
  </div>
);

const ConditionItem = ({ condition, isFirst = false }) => {
  // If it's a nested condition with operator and conditions, render them recursively
  if (condition.operator && Array.isArray(condition.conditions)) {
    return (
      <div className="flex items-center">
        {!isFirst && <OperatorLabel operator={condition.operator} />}
        <div className="flex items-center flex-wrap gap-2">
          {condition.conditions.map((cond, idx) => (
            <React.Fragment key={idx}>
              {idx > 0 && <OperatorLabel operator={condition.operator} isFirst={idx === 0} />}
              <ConditionItem condition={cond} isFirst={idx === 0} />
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  // Regular condition item
  return (
    <div className="flex items-center bg-white border border-gray-200 rounded px-2 py-1 h-8 w-fit">
      <span className="text-sm font-medium text-gray-700 whitespace-nowrap">
        {condition.criteria === condition.field
          ? condition.criteria
          : `${condition.criteria} - ${condition.field}`}
      </span>
      <span className="mx-2 text-gray-300"> </span>
      <span className="text-sm text-gray-500 whitespace-nowrap">{condition.operatorLabel || condition.operator}</span>
      <span className="mx-2 text-gray-300"> </span>
      <span className="text-sm font-medium text-gray-900 whitespace-nowrap">
        {condition.display_value !== undefined ? condition.display_value : condition.value}
      </span>
    </div>
  );
};

const AudienceSetFiltersView = ({ filters }) => {
  if (!filters) return null;
  
  // Handle direct condition object case
  const renderContent = () => {
    // Case 1: Direct condition object (has field and operator)
    if (filters.field && filters.operator !== undefined) {
      return <ConditionItem condition={filters} isFirst={true} />;
    }
    
    // Case 2: Nested structure with operator and conditions
    if (filters.operator && Array.isArray(filters.conditions)) {
      return (
        <div className="flex items-center">
          <ConditionItem condition={filters} isFirst={true} />
        </div>
      );
    }
    
    // Case 3: Array of conditions (treated as AND between them)
    if (Array.isArray(filters)) {
      return (
        <div className="flex items-center flex-wrap gap-2">
          {filters.map((condition, index) => (
            <React.Fragment key={index}>
              <ConditionItem condition={condition} isFirst={index === 0} />
            </React.Fragment>
          ))}
        </div>
      );
    }
    
    // Fallback: If none of the above, don't render anything
    return null;
  };

  return (
    <div className="w-full">
      {renderContent()}
    </div>
  );
};

export default AudienceSetFiltersView;
